import { useContext } from 'react';
import { Spacer } from '@nx-kit/layout';
import { useRouter } from 'next/router';
import useIsSticky from 'hooks/useIsSticky';
import { GUIDE_BASE } from 'prismic/config';
import { generateLanguageOptions } from 'helpers/header.helper';
import { BreakpointContext } from 'contexts/breakpoint/BreakpointContext';
import Link from 'components/atoms/Link/Link';
import {
  LanguageSwitcherDesktop,
  LanguageSwitcherMobile,
} from 'components/molecules/LanguageSwitcher';
import Meta from 'components/organisms/Header/partials/desktop/Meta';
import { HeaderGuideProps } from './HeaderGuide.types';
import { Bar, StyledHeader, StyledLogo } from './HeaderGuide.styles';

export const HeaderGuide: React.FC<HeaderGuideProps> = ({ alternateLanguages, meta_links }) => {
  const { locale } = useRouter();
  const { isSticky, isStickyProps } = useIsSticky();
  const bp = useContext(BreakpointContext);
  const isMobile = bp === 'xs' || bp === 'sm';
  // options
  const languageOptions = generateLanguageOptions(alternateLanguages);

  return (
    <>
      <div {...isStickyProps}></div>
      <StyledHeader>
        {!isMobile && <Meta links={meta_links} languageOptions={languageOptions} />}
        <Bar isSticky={isSticky}>
          <Link url={{ link_type: 'Web', url: `/${locale}/${GUIDE_BASE}` }}>
            <StyledLogo />
          </Link>
          <Spacer />
          {isMobile ? (
            <LanguageSwitcherMobile withWhiteSkin withShortText options={languageOptions} />
          ) : (
            <LanguageSwitcherDesktop withWhiteSkin withShortText options={languageOptions} />
          )}
        </Bar>
      </StyledHeader>
    </>
  );
};
